/* Copyright (c) 2020-2022 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Link } from "react-router-dom";
import { Spacer } from "@nordcloud/gnui";
import { Table } from "~/components";
import { CollapseItem } from "~/components/CollapseItem/CollapseItem";
import { reqTableColumns } from "~/components/Requests/tableColumns";
import FlexContainer from "~/components/Styled/FlexContainer";
import { CustomerRequest, CustomerService } from "~/models";
import { ROUTES } from "~/routing";
import AssignRequest from "./AssignRequest";
import UnassignRequest from "./UnassignRequest";
import UnassignService from "./UnassignService";

type Props = {
  service: CustomerService;
  refetch: () => Promise<void>;
  canEdit: boolean;
};

export default function ({ service, refetch, canEdit }: Props) {
  const columns = reqTableColumns<CustomerRequest>("category.name");

  if (canEdit) {
    columns.push({
      Header: "Actions",
      accessor: "",
      width: "60px",
      Cell: ({ row }) => (
        <FlexContainer>
          <UnassignRequest request={row.original} refetch={refetch} />
        </FlexContainer>
      ),
    });
  }

  return (
    <CollapseItem
      buttons={
        canEdit && (
          <>
            <UnassignService service={service} refetch={refetch} />
            <AssignRequest
              serviceId={service.id}
              assignedRequests={service.requests}
              refetch={refetch}
            />
          </>
        )
      }
      name={
        <Link to={`${ROUTES.services.index}/${service.id}`}>
          {service.name}
        </Link>
      }
    >
      <Spacer height="1rem" />
      {service.requests.length ? (
        <Table columns={columns} data={service.requests} mb="0" />
      ) : (
        "No requests assigned"
      )}
    </CollapseItem>
  );
}
